import React, { useContext, useState, useCallback, useRef, useEffect } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import DropdownMoreIcon from "../../../../../components/SVGComponents/DropdownMoreIcon";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
} from "@fluentui/react";
import FilterPopUp from "../FilterPopUp";
import { t } from "i18next";
import loaderContext from "../../../../../context/loader/LoaderContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import {MAX_FILTER_BADGES_LENGTH, MAX_FILTER_BADGES_LENGTH_LARGE_SCREEN, REPORTED_SUBTABS_ID, RESPONSIVE_BADGE_BREAKPOINT, USERTYPES} from '../../../../../constants/Constants';
import { T } from "@kitware/vtk.js/macros2";

const ContentFilter = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    setApplyClick,
    filterBadges,
    setFilterBadges,
    removeBadgeFromFilter,
    storefilterBadges,
    setPatientDetail,
    trackApplyButton,
    setTrackApplyButton,
    patientNameBadgeShow,
    setPatientNameBadgeShow,
    handleEnterKeyPress,
    setFilterInputValues,
    storefilterInputValues,
    handleRefresh,
    selectedValue,
    roles,
  } = useContext(studylistContext);

  const { getThemeColor } = useContext(themeContext);

  const { enableButtonTourPurpose,setEnableButtonTourPurpose } = useContext(loaderContext); 

  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState(false);

  const onHoverIn = () => {
    setShowMoreFilter(true);
  };
  const onHoverOut = () => {
    setShowMoreFilter(false);
  };
  
  useEffect(()=>{
    if(enableButtonTourPurpose.showFilterPopup){
      setShowFilterOptions(true);
    }else{
      setShowFilterOptions(false);
    }
  },[enableButtonTourPurpose])

  
   const getMaxBadgesForScreen = () => {
     if (window.innerWidth < RESPONSIVE_BADGE_BREAKPOINT) {
      return MAX_FILTER_BADGES_LENGTH; // 4 for small screens (< 1200px)
      }
      return MAX_FILTER_BADGES_LENGTH_LARGE_SCREEN; // 2 for large screens (>= 1200px)
    };  

    const [maxFilterBadgesLength, setMaxFilterBadgesLength] = useState(getMaxBadgesForScreen());

    useEffect(() => {
      if (REPORTED_SUBTABS_ID.includes(selectedValue)) {
        if (roles?.[0] == USERTYPES.SUPERVISOR || roles?.[0] == USERTYPES.FIRM_ADMIN || roles?.[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR ) {
          setMaxFilterBadgesLength(1);
        } else if (window.innerWidth < RESPONSIVE_BADGE_BREAKPOINT) {
          setMaxFilterBadgesLength(1);
        } else {
          setMaxFilterBadgesLength(MAX_FILTER_BADGES_LENGTH_LARGE_SCREEN);
        }
      } else {
        setMaxFilterBadgesLength(getMaxBadgesForScreen());
      }
    }, [selectedValue, roles]);

  // Handle window resize to update badge count responsively
    useEffect(() => {
      const handleResize = () => {
        if (REPORTED_SUBTABS_ID.includes(selectedValue)) {
          if (roles?.[0] == USERTYPES.SUPERVISOR || roles?.[0] == USERTYPES.FIRM_ADMIN || roles?.[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR ) {
            setMaxFilterBadgesLength(1);
          } else if (window.innerWidth < RESPONSIVE_BADGE_BREAKPOINT) {
            setMaxFilterBadgesLength(1);
          } else {
            setMaxFilterBadgesLength(MAX_FILTER_BADGES_LENGTH_LARGE_SCREEN);
          }
        } else {
          setMaxFilterBadgesLength(getMaxBadgesForScreen());
        }
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [selectedValue]);

  
   const addIcon = {
    iconName: "AddTo",
    cursor: "pointer",
  }; 
   const addFilterActive = {
    rootHovered:{
      background:"red"
    },
    root:{
      fontSize: "12px",
      fontWeight: "400",
      padding: "0px 3px",
      whiteSpace: "nowrap",
      background: "#404040",
      borderColor: "#404040",
      borderRadius: "7px !important",
      minWidth: "71px"
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: storefilterBadges?.length > 0 ? "50%" : "fit-content",
        }}
      >
        <div style={{ display: "flex",marginLeft:'0px' }}>
          <TooltipHost content={t("label.filter")}>
          <PrimaryButton
            iconProps={{ iconName: 'Filter' }}
            // TooltipHostProps={{ content: t("label.filter") }}
            onClick={() => {
              setShowFilters((prev) => !prev);
              setShowFilterOptions((prev) => !prev);
            }}
            styles={{
              root: {
                height: '32px',
                minWidth: '32px',
                padding: '0px'
              },
              icon: {
                fontSize: '16px'
              }
            }}
          />
          </TooltipHost>
        </div>
          <div style={{ marginLeft:'5px' }}>
            {storefilterBadges?.length > 0 && (
            <TooltipHost content={t("label.clear")}>
            <PrimaryButton
              iconProps={{ iconName: 'Delete' }}
              onClick={() =>
                setTimeout(() => {
                  props.handleClearFilter();
                }, 500)
              }
              styles={{
                root: {
                  height: '32px',
                  minWidth: '32px',
                  padding: '0px'
                },
                icon: {
                  fontSize: '16px'
                }
              }}
            />
            </TooltipHost>
            )}
          </div>
         
        {storefilterBadges?.length > 0 &&
          storefilterBadges.map(
            (item, ind) => {
              return (
                ind <= maxFilterBadgesLength-1 && (
                  <TooltipHost content={item.label.replace(/^__p_/i, "")} key={ind}>
                  <div
                    // key={ind}
                    className="study-list-badge-list-view"
                    style={{ marginLeft:  ind === 0 ? "10px" : "10px", cursor: "auto" }}
                  >
                    <span className="study-list-badge-text-list-view">
                      {item.label.replace(/^__p_/i, "")}
                    </span>

                     <Icon
                      onClick={(event) => {
                        event.stopPropagation();
                        removeBadgeFromFilter(item);
                      }}
                      style={{
                        cursor: "pointer",
                        lineHeight: "2",
                        marginLeft: "5px",
                      }}
                      iconName="Cancel"
                      className="ms-fontSize-10"
                    ></Icon> 
                  </div>
                  </TooltipHost>
                )
              );
            }

            // </ScrollMenu>
          )}

        {storefilterBadges?.length > maxFilterBadgesLength &&
          // <ScrollMenu
          //   LeftArrow={LeftArrowFunction}
          //   RightArrow={RightArrowFunction}
          //   onInit={restorePosition}
          //   onScroll={savePosition}
          //   onWheel={onWheel}
          //   apiRef={apiRef}
          // >
          storefilterBadges.map(
            (item, ind) => {
              return (
                ind == maxFilterBadgesLength && (
                  <div
                    key={ind}
                    className="study-list-badge-list-view more-filter-hover"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    onMouseEnter={onHoverIn}
                    onMouseLeave={onHoverOut}
                    //onClick={() => setShowFilterOptions(true)}
                  >
                    <span className="study-list-badge-text-list-view">
                      {/* +{storefilterBadges.length - (maxFilterBadgesLength > 1 ? maxFilterBadgesLength - 1: maxFilterBadgesLength) - 1}&nbsp; */}
                      +{storefilterBadges.slice(maxFilterBadgesLength, storefilterBadges.length).length}&nbsp;
                      <DropdownMoreIcon />
                    </span>
                    {showMoreFilter && (
                      <div
                        className="more-popup-hover modal-scroll"
                        style={{border: getThemeColor("border")}}
                        onMouseEnter={onHoverIn}
                        onMouseLeave={onHoverOut}
                      >
                        {storefilterBadges.map((item, ind) => {
                          return (
                            ind > (maxFilterBadgesLength - 1) && (
                              <TooltipHost content={item.label.replace(/^__p_/i, "")} key={ind}>
                              <div
                                // key={ind}
                                className="study-list-badge-list-view"
                                style={{
                                  marginLeft: "10px",
                                  cursor: "auto",
                                  marginBottom: "10px",
                                }}
                              >
                                <span className="study-list-badge-text-list-view">
                                  {item.label.replace(/^__p_/i, "")}
                                </span>

                                <Icon
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    removeBadgeFromFilter(item);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    // color: "white",
                                    lineHeight: "2",
                                    marginLeft: "5px",
                                  }}
                                  iconName="Cancel"
                                  className="ms-fontSize-10"
                                ></Icon>
                              </div>
                              </TooltipHost>
                            )
                          );
                        })}
                      </div>
                    )}
                  </div>
                )
              );
            }

          )}
      </div>
      
      <FilterPopUp
        show={showFilterOptions}
        onClickOutside={() => {
          setFilterInputValues(storefilterInputValues);
          setShowFilterOptions(false);
        }}
        setShowFilterOptions={setShowFilterOptions}
      />
    </>
  );
};

export default ContentFilter;
